import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/authenticationActions';
import { XMarkIcon } from '@heroicons/react/20/solid';
import MFASetup from './MFASetup';

const MFAModal = ({
    mfa,
    setMFAModalStatus,
    profileLoaded,
}) => {

    if (!profileLoaded || !mfa.isModalOpen) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ overflow: "auto", display: "block", background: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b">
                        <div className="block-header bg-primary-dark">
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => setMFAModalStatus(false)}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Enable Multi-Factor Authentication</h3>
                        </div>
                        <MFASetup />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {

    return {
        mfa: state.my.mfa,
        profileLoaded: !!state?.my?.profile?.email,
    }
}

const mapDispatchToProps = dispatch => ({
    setMFAModalStatus: (status) => dispatch(ACTIONS.setMFAModalStatus(status)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MFAModal);